import axios from "axios";

export default {
  namespaced: true,
  state: {
    lista: [],
    perPage: 100,
    // Filtros
    filtroContaId: null,
    filtroBancoId: null,
    filtroEmpresaId: null,
    filtroDataInicial: '',
    filtroDataFinal: '',
    filtroStatus: '',
    filtroNomeArquivo: '',
    // Controles
    registroSelecionadoId: null,
    paginaAtual: 1,
    recarregarLista: false,
    // Dados da conciliação em edição
    conciliacaoAtual: null,
    itensConciliacao: [],
    itemSelecionado: null,
    // Candidatos para vínculo
    candidatosRBANMOV1: [],
    // Vínculos
    vinculosItemSelecionado: []
  },
  getters: {
    LISTA: state => state.lista,
    PER_PAGE: state => state.perPage,
    FILTRO_CONTA_ID: state => state.filtroContaId,
    FILTRO_BANCO_ID: state => state.filtroBancoId,
    FILTRO_EMPRESA_ID: state => state.filtroEmpresaId,
    FILTRO_DATA_INICIAL: state => state.filtroDataInicial,
    FILTRO_DATA_FINAL: state => state.filtroDataFinal,
    FILTRO_STATUS: state => state.filtroStatus,
    FILTRO_NOME_ARQUIVO: state => state.filtroNomeArquivo,
    REGISTRO_SELECIONADO_ID: state => state.registroSelecionadoId,
    PAGINA_ATUAL: state => state.paginaAtual,
    RECARREGAR_LISTA: state => state.recarregarLista,
    CONCILIACAO_ATUAL: state => state.conciliacaoAtual,
    ITENS_CONCILIACAO: state => state.itensConciliacao,
    ITEM_SELECIONADO: state => state.itemSelecionado,
    CANDIDATOS_RBANMOV1: state => state.candidatosRBANMOV1,
    VINCULOS_ITEM_SELECIONADO: state => state.vinculosItemSelecionado
  },
  mutations: {
    SET_LISTA: (state, payload) => {
      state.lista = payload
    },
    SET_PER_PAGE: (state, payload) => {
      state.perPage = payload
    },
    SET_FILTRO_CONTA_ID: (state, payload) => {
      state.filtroContaId = payload
    },
    SET_FILTRO_BANCO_ID: (state, payload) => {
      state.filtroBancoId = payload
    },
    SET_FILTRO_EMPRESA_ID: (state, payload) => {
      state.filtroEmpresaId = payload
    },
    SET_FILTRO_DATA_INICIAL: (state, payload) => {
      state.filtroDataInicial = payload
    },
    SET_FILTRO_DATA_FINAL: (state, payload) => {
      state.filtroDataFinal = payload
    },
    SET_FILTRO_STATUS: (state, payload) => {
      state.filtroStatus = payload
    },
    SET_FILTRO_NOME_ARQUIVO: (state, payload) => {
      state.filtroNomeArquivo = payload
    },
    SET_REGISTRO_SELECIONADO_ID: (state, payload) => {
      state.registroSelecionadoId = payload
    },
    SET_PAGINA_ATUAL: (state, payload) => {
      state.paginaAtual = payload
    },
    SET_LIMPAR: (state) => {
      state.filtroContaId = null
      state.filtroBancoId = null
      state.filtroEmpresaId = null
      state.filtroDataInicial = ''
      state.filtroDataFinal = ''
      state.filtroStatus = ''
      state.filtroNomeArquivo = ''
      state.paginaAtual = 1
    },
    SET_RECARREGAR_LISTA: (state, payload) => {
      state.recarregarLista = payload
    },
    SET_CONCILIACAO_ATUAL: (state, payload) => {
      state.conciliacaoAtual = payload
    },
    SET_ITENS_CONCILIACAO: (state, payload) => {
      state.itensConciliacao = payload
    },
    SET_ITEM_SELECIONADO: (state, payload) => {
      state.itemSelecionado = payload
    },
    SET_CANDIDATOS_RBANMOV1: (state, payload) => {
      state.candidatosRBANMOV1 = payload
    },
    SET_VINCULOS_ITEM_SELECIONADO: (state, payload) => {
      state.vinculosItemSelecionado = payload
    }
  },
  actions: {
    GET_LISTA: async (context) => {
      try {
        const params = {
          contaId: context.state.filtroContaId,
          bancoId: context.state.filtroBancoId,
          empresaId: context.state.filtroEmpresaId,
          dataInicial: context.state.filtroDataInicial,
          dataFinal: context.state.filtroDataFinal,
          status: context.state.filtroStatus,
          nomeArquivo: context.state.filtroNomeArquivo
        }
        const { data } = await axios.get('/api/protected/conciliacao-bancaria/pesquisar', { params })
        context.commit('SET_LISTA', data)
        return data
      } catch (error) {
        console.error('Erro ao buscar lista de conciliações', error)
        throw error
      }
    },
    GET_BY_ID: async (context, id) => {
      try {
        const { data } = await axios.get(`/api/protected/conciliacao-bancaria/getById/${id}`)
        context.commit('SET_CONCILIACAO_ATUAL', data[0])
        return data[0]
      } catch (error) {
        console.error('Erro ao buscar conciliação', error)
        throw error
      }
    },
    GET_ITENS: async (context, conciliacaoId) => {
      try {
        const { data } = await axios.get(`/api/protected/conciliacao-bancaria/itens/${conciliacaoId}`)
        context.commit('SET_ITENS_CONCILIACAO', data)
        return data
      } catch (error) {
        console.error('Erro ao buscar itens da conciliação', error)
        throw error
      }
    },
    GET_CANDIDATOS_RBANMOV1: async (context, params) => {
      try {
        const { data } = await axios.get('/api/protected/conciliacao-bancaria/candidatos-rbanmov1', { params })
        context.commit('SET_CANDIDATOS_RBANMOV1', data)
        return data
      } catch (error) {
        console.error('Erro ao buscar candidatos RBANMOV1', error)
        throw error
      }
    },
    GET_VINCULOS: async (context, conciliacaoItemId) => {
      try {
        const { data } = await axios.get(`/api/protected/conciliacao-bancaria/vinculos/${conciliacaoItemId}`)
        context.commit('SET_VINCULOS_ITEM_SELECIONADO', data)
        return data
      } catch (error) {
        console.error('Erro ao buscar vínculos', error)
        throw error
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modulos/conciliacao-bancaria-store.js